var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-ui"},[_c('ui-layout',{staticClass:"discovery__page",attrs:{"direction":"column"}},[_c('ui-page-title-bar',{attrs:{"title":"Discovered Assets"}}),_vm._v(" "),_c('discovery',{staticClass:"page-gutter page-content--lg",attrs:{"organisationId":_vm.organisationId,"suppressedOnly":_vm.isSuppressed}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }